import { render } from "./UpdateWarehouse.vue?vue&type=template&id=094d4270&ts=true"
import script from "./UpdateWarehouse.vue?vue&type=script&lang=ts"
export * from "./UpdateWarehouse.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__